// src/components/Common/EventLanding/One/HouseRules.jsx
import React from "react";
import { FaRegClock } from "react-icons/fa6";
import { GrMicrophone } from "react-icons/gr";
import { IoHandLeftOutline } from "react-icons/io5";
import "./houseRules.scss";

const HouseRules = ({ eventDetails }) => {
  // Use event-specific rules if available, fallback to defaults
  const rules = eventDetails?.houseRules?.length > 0 
    ? eventDetails.houseRules.map((rule, idx) => ({
        icon: <GrMicrophone size={28} color="#000" />,
        text: rule
      }))
    : [
        {
          icon: <GrMicrophone size={28} color="#000" />,
          text: "Check your mute/unmute button",
        },
        {
          icon: <FaRegClock size={28} />,
          text: "Respect everyone's time by keeping to the schedule",
        },
        {
          icon: <IoHandLeftOutline size={28} />,
          text: "Raise Your Hand Before You Can Speak",
        },
      ];

  if (!rules || rules.length === 0) return null;

  return (
    <div className="house-rules-container">
      <h3 style={{ textAlign: "center", marginBottom: "20px", color: "#333", width: "100%" }}>
        House Rules
      </h3>
      {rules.map((rule, index) => (
        <div className="rule-card" key={index}>
          <div className="icon">{rule.icon}</div>
          <div className="houseDivider"></div>
          <div className="text">{rule.text}</div>
        </div>
      ))}
    </div>
  );
};

export default HouseRules;